module.exports = __webpack_public_path__ + "img/details-img-02.f8ef7544.png";